import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIconButton from "../../../../components/CloseIconButton";

interface ProducerCodeLogsContentModalProps {
  showFullView: boolean;
  closeFullView: () => void;
}
export const ProducerCodeLogsContentModal: React.FC<
  ProducerCodeLogsContentModalProps
> = ({ showFullView, closeFullView, children }) => {
  return (
    <>
      <Transition appear show={showFullView} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto bg-black bg-opacity-40 py-10"
          onClose={() => {}}
        >
          <div className="min-h-full px-10 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="sm:w-7/5 lg:w-8/12 inline-block  border-primary border-l-6  px-4 pb-3 pt-2 text-left align-middle transition-all 
                  transform bg-white shadow-xl brContainer relative"
              >
                <div>{children}</div>
                <CloseIconButton onClick={closeFullView} />
                <div className="text-xs max-h-fit"></div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
